
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export default function BlogCard(props) {
 const blogsData = props.data
 const navigate = useNavigate();
 
 const getDetail = (id) => {
    if (id) {
      navigate(`../blogs/blog-detail?id=${id}`);
    }
  };

  return (
    <div className="TrandingArtistMaineBox blogBoxNew"  onClick={() => getDetail(blogsData?._id)}>
    <div className="imgBox">
      <div className="imginn">
        <img
          className="img-fluid"
          src={blogsData?.image?.link}
          alt=""
        />
      </div>
    </div>
    <div className="contBox">
      <div className="arthead mb-2">
        <h2 className="productName" title= {blogsData?.title}>{blogsData?.title}</h2>
      </div>
      <div className="post_content" dangerouslySetInnerHTML={{
    __html: blogsData?.description ||  `<div className="d-flex align-items-center justify-content-center">
    <p>Loading....</p>
  </div>`,
}}></div>
    
      <h2 className="datetext"> {moment(blogsData?.date_created).format("DD  MMM yy")}</h2>
    </div>
   
  </div>
  
 
  );
}
